<template>
  <div class="whole" :style="{height:pub_height+'px'}">
    <div class="no_content" aspectratio-center>
      <div class="icon">
        <img :src="icon"/>
      </div>
      <div class="content">功能正在开发中，敬请期待</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      icon:require('../assets/none.png')
    };
  },
  mounted() {},
  methods: {},
  computed: mapState(["pub_height"])
};
</script>
<style lang="scss" scoped>
.whole {
  @include none-pic;
  position: relative;
}
</style>